import { OSS_CONFIG } from '~/config/oss'

/**
 * 获取完整的OSS图片URL
 * @param path 图片相对路径
 * @param options 可选参数
 * @returns 完整的图片URL
 */
export function useOssImage(path: string, options?: { width?: number; height?: number; quality?: number }): string {
  if (!path) {
    return ''
  }
  
  // 如果已经是完整URL，直接返回
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }
  
  // 处理相对路径
  const fullPath = path.startsWith('/') ? path : `/${path}`
  const imageUrl = `${OSS_CONFIG.domain}${OSS_CONFIG.imagePrefix}${fullPath}`
  
  // 如果有图片处理参数，添加到URL中
  if (options && (options.width || options.height || options.quality)) {
    const params = new URLSearchParams()
    if (options.width) params.append('x-oss-process', `image/resize,w_${options.width}`)
    if (options.height) params.append('x-oss-process', `image/resize,h_${options.height}`)
    if (options.quality) params.append('x-oss-process', `image/quality,q_${options.quality}`)
    
    return `${imageUrl}?${params.toString()}`
  }
  
  return imageUrl
}
